import React from 'react';
import styled from '@emotion/styled';
import { ArrowButton, TextButton } from '../../../../../ui';
import { useTranslation } from '../../../../shared/i18n/translate/useTranslation';
import {
	Dialog,
	DialogHeader,
	DialogMain,
} from '../../../../shared/components/dialog';
import { ApiErrorMessage } from '../../errors/ApiErrorMessage';

export interface ICancelBookingDialogProps {
	onConfirm: () => void;
	onAbort: () => void;
	disabled?: boolean;
	error?: Error;
}

export const CancelBookingDialog = ({
	onConfirm,
	onAbort,
	disabled,
	error,
}: ICancelBookingDialogProps) => {
	const { t } = useTranslation();

	return (
		<Dialog
			ariaLabel={t('parking_booking_cancel_alert_title')}
			onClose={onAbort}
		>
			<DialogHeader>
				<h3>{t('parking_booking_cancel_alert_title')}</h3>
			</DialogHeader>
			<DialogMain wideContent>
				<p>{t('parking_booking_cancel_alert_message')}</p>
				<ActionsWrap>
					<TextButton disabled={disabled} onClick={onAbort}>
						{t('parking_booking_cancel_alert_cancel_button')}
					</TextButton>
					<ArrowButton disabled={disabled} onClick={onConfirm}>
						{t('parking_booking_cancel_alert_confirm_button')}
					</ArrowButton>
				</ActionsWrap>
				{error && <ApiErrorMessage error={error} />}
			</DialogMain>
		</Dialog>
	);
};

const ActionsWrap = styled.div`
	display: flex;
	justify-content: space-between;
`;
